<script setup>
import { computed } from 'vue';
import MapComponent from '@components/MapComponent.vue';
import CardMenu from '@components/CardMenu.vue';



import { useWorkspaceStore } from '@stores/WorkspaceData';
const wpStore = useWorkspaceStore()
// «Горизонт моделирования» показывается карточкой поверх карты; если карту выключили — обычной панелью
const overlayOnMap = computed(() => wpStore.selectComponent === 'time' && wpStore.mapShow)
const showContentPanel = computed(() => !!wpStore.selectComponent && !overlayOnMap.value)
const panelsKey = computed(() => `${wpStore.mapShow}-${showContentPanel.value}`)
</script>

<template>
<section class="MainSection">
  <CardMenu />
    <!-- Splitter задаёт размеры панелей только при создании: при смене набора панелей пересоздаём его,
         иначе включённая позже карта получает нулевую высоту -->
    <Splitter layout="vertical" ref="splitterRef" class="SplitterMain" :key="panelsKey">
      <SplitterPanel :size="showContentPanel ? 40 : 100" :minSize="20" v-if="wpStore.mapShow" style="position: relative;">
        <MapComponent />
        <div v-if="overlayOnMap" class="MapOverlay"><router-view /></div>
      </SplitterPanel>
      <SplitterPanel :size="wpStore.mapShow ? 60 : 100" :minSize="10" v-if="showContentPanel" style="overflow: auto;">
        <router-view />
      </SplitterPanel>
  </Splitter>

</section>
</template>

<style>
.MainSection{
  height: 100%;
  display: flex;
}
.MainSection .p-splitter{
  height: calc(100vh - 10px);
  flex: 1 1 0%;
  margin: 5px;
  background: none;
  border: none;
}
.MainSection .p-splitter .p-splitterpanel{
  background: var(--p-splitter-background);
  border-radius: var(--p-border-radius-md);
  border: 1px solid var(--p-splitter-border-color);
}
.MainSection .p-splitter .p-splitter-gutter{
  background: none;
}
/* Карточка раздела поверх карты */
.MapOverlay{
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  max-width: calc(100% - 80px);
  max-height: calc(100% - 60px);
  overflow: auto;
  background: var(--p-content-background);
  border: 1px solid var(--p-content-border-color);
  border-radius: var(--p-content-border-radius);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
}
.MapOverlay .SectionPanel .p-fieldset{
  margin: 0 !important;
  border: none;
}


</style>
